// Copyright (c) 2019 Deere & Company

import {addRemoveModalClass} from '../../../shared/services/add-remove-modal-class';
import {getClaimAction} from '../../shared/services/claim-shared-helper';

export const toggleWarrentyStatusModal = (claimType, isOpen) =>

    dispatch => {

        addRemoveModalClass(isOpen);

        dispatch({
            isOpen,
            type: `TOGGLE_CLAIM_${getClaimAction(claimType)}_WARRANTY_STATUS_MODAL`
        });

    };




// WEBPACK FOOTER //
// ./src/claim/shared/action-creators/warranty-status-modal.js